import React from 'react';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import classNames from 'classnames';
import styles from './SortIcon.module.scss';

type SortIconProps = {
    isDesc: boolean;
    onClick?: (e: any) => void;
    disabled?: boolean;
    componentClasses?: string;
    isActive?: boolean;
    isNewDesign?: boolean;
};

const getIconActiveColor = (isActive, isNewDesign) => {
    if (isNewDesign) {
        return isActive ? 'secondary-500' : 'secondary-400';
    }
    return isActive ? 'primary-500' : 'secondary-400';
};

export const SortIcon = ({
    isNewDesign,
    isDesc,
    onClick,
    disabled,
    componentClasses,
    isActive = true
}: SortIconProps) => (
    <div
        className={classNames(
            {
                [styles.component]: !isNewDesign,
                [styles.disabled]: disabled
            },
            componentClasses
        )}
        onClick={!disabled ? onClick : undefined}
    >
        <Icon
            icon={PriorityIcon.arrowDropUp}
            iconColor={getIconActiveColor(!isDesc && isActive, isNewDesign)}
            componentClasses={classNames(styles.icon, styles.topArrow)}
        />
        <Icon
            icon={PriorityIcon.arrowDropDown}
            iconColor={getIconActiveColor(isDesc && isActive, isNewDesign)}
            componentClasses={classNames(styles.icon, styles.bottomArrow)}
        />
    </div>
);
